import React, { useEffect, useMemo, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from "react-router-dom";
import "./Arowbutton.css";
import "./header.css";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import "./loader.css";
import { useCart } from "./CartContext";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";

function Wishlist() {
  let navigate = useNavigate();
  const { triggerCartRefresh, cartRefresh } = useCart();
  let token = secureLocalStorage.getItem("n_token");
  let _id = secureLocalStorage.getItem("n_id");
  let [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, [cartRefresh]);

  const fetchData = async () => {
    try {
      let data = {
        user_id: _id,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/get_favourite_product_list`,
        data,
        {
          headers: { token },
        },
      );

      if (res?.data?.result) {
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
      if (axios.isCancel(error)) {
        console.log("Request aborted");
      } else {
        console.log(error);
      }
    }
  };
  let Single_products = (productId) => {
    navigate(`/single_products/${productId}`);
  };

  let handleLogin = () => {
    navigate(`/login`);
  };

  const addfevrate = async (productsid) => {
    try {
      const items = {
        user_id: _id,
        product_id: productsid,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
        {
          headers: { token },
        },
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        triggerCartRefresh();
        fetchData();
      } else {
        toast.error(res.data.msg || "Something went wrong");
      }
    } catch (error) {
      toast.error("Product removed from favourites successfully.");
      fetchData();
    }
  };

  return (
    <>
      <ToastContainer position="top-center" />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>

      <section
        className="new-arrival-carousel-section"
        style={{ marginBottom: "40px" }}
      >
        <div className="container-fluid mt-5">
          <div className="faq-header">
        
        <h2>Wishlist</h2>
      </div>
          <br />

          <div
            className="vertical-scroll-container"
            style={{ marginBottom: "20px" }}
          >
            <div className="row g-3">
              {data?.slice(0, 8).map((items) => {
                return (
                  <div className="new-arrival-carousel-item swiper-slide col-xl-3 col-lg-3 col-md-4 col-6">
                    <div
                      className="product-card-list"
                      style={{ marginRight: "-10px", cursor: "pointer" }}
                    >
                      <div
                        className="product-card"
                        onClick={() => Single_products(items.product_id)}
                      >
                        <div className="product-thumb-nail">
                          <span>
                            <img
                              className="product-image p-2"
                              src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                              alt="image_not_found"
                            />
                          </span>
                          <ul className="actions">
                            {_id ? (
                              items.favourite_status == 1 ? (
                                <li className="action whish-list">
                                  <BsFillSuitHeartFill
                                    style={{ color: "red" }}
                                    onClick={() => addfevrate(items._id)}
                                  />
                                </li>
                              ) : (
                                <li
                                  className="action whish-list"
                                  onClick={() =>
                                    addfevrate(
                                      items._id,
                                      items.favourite_status,
                                    )
                                  }
                                >
                                  <i className="lar la-heart" />
                                </li>
                              )
                            ) : (
                              <li className="action whish-list">
                                <button>
                                  <a href="/login">
                                    <i className="lar la-heart" />
                                  </a>
                                </button>
                              </li>
                            )}

                            <li className="action quick-view">
                              {_id ? (
                                <button
                                  data-toggle="modal"
                                  data-target="#dealsofdaymodal"
                                >
                                  <i
                                    className="las la-eye"
                                    onClick={() => Single_products(items.product_id)}
                                  />
                                </button>
                              ) : (
                                <a href="/login">
                                  <button>
                                    <i className="las la-eye" />
                                  </button>
                                </a>
                              )}
                            </li>
                          </ul>
                        </div>

                        <div className="product-content">
                          <h4 className="product-sub-title">
                            <a href="#">{items.category_name}</a>
                          </h4>
                          {_id ? (
                            <a href="#">
                              <h3
                                className="product-title"
                                onClick={() => Single_products(items.product_id)}
                              >
                                {items.product_name}
                              </h3>
                            </a>
                          ) : (
                            <a href="#">
                              <h3
                                className="product-title"
                                onClick={() => handleLogin(items._id)}
                              >
                                {items.product_name}
                              </h3>
                            </a>
                          )}

                          {/* Product Specifications */}
                          <div className="product-specs mb-2">
                            <div className="spec-item d-flex justify-content-between">
                              <span className="text-black">Weight:</span>
                              <span className="text-muted">
                                {items.weight || "N/A"}
                              </span>
                            </div>
                            <div className="spec-item d-flex justify-content-between">
                              <span className="text-black">Shape:</span>
                              <span className="text-muted">
                                {items.shape || "N/A"}
                              </span>
                            </div>
                            <div className="spec-item d-flex justify-content-between">
                              <span className="text-black">Origin:</span>
                              <span className="text-muted">
                                {items.origin || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Price Section */}
                          <div className="product-price-wrapp  mb-3">
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              {items.available_status?.includes("Buy") && (
                                <>
                                  <span
                                    style={{
                                      color: "black",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      padding: "3px 6px",
                                      borderRadius: "4px",

                                      lineHeight: "1",
                                    }}
                                  >
                                    Best Buy:
                                  </span>

                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      color: "black",
                                    }}
                                  >
                                    ₹{items.sale_price?.toLocaleString()}
                                  </span>
                                </>
                              )}
                            </div>

                            <p
                              style={{
                                color: "#ff5722",
                                marginTop: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              OR
                            </p>

                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <span
                                style={{
                                  color: "black",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  padding: "3px 6px",
                                  borderRadius: "4px",

                                  lineHeight: "1",
                                }}
                              >
                                Leasing starts from
                              </span>

                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                  color: "#ff5722",
                                }}
                              >
                                ₹{items.lease_price?.toLocaleString()}
                              </span>
                            </div>

                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <span
                                style={{
                                  color: "black",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  padding: "3px 6px",
                                  borderRadius: "4px",

                                  lineHeight: "1",
                                }}
                              >
                                Security Deposit
                              </span>

                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "700",
                                  color: "black",
                                }}
                              >
                                ₹{items.rent_price?.toLocaleString()}
                              </span>
                            </div>
                          </div>

                          <div className="product-cart-btn-wrap">
                            <button
                              onClick={() => Single_products(items.product_id)}
                              className="btn btn-success add-to-cart-btn btn-lg w-100 py-3"
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Wishlist;
